import { AddOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { alpha } from '@mui/material/styles';

interface BelowTableAddButtonProps {
    label: string;
    onClick: () => void;
}

export const BelowTableAddButton = ({ label, onClick }: BelowTableAddButtonProps) => (
    <Button
        onClick={onClick}
        startIcon={<AddOutlined sx={{ width: 18, height: 18 }} />}
        sx={(theme) => ({
            width: 'min(420px, 100%)',
            minHeight: 38,
            px: '18px',
            border: '1px dashed',
            borderColor: alpha(theme.palette.primary.main, 0.5),
            borderRadius: '14px',
            bgcolor: alpha(theme.palette.primary.main, 0.06),
            color: theme.palette.primary.dark,
            fontSize: 14,
            fontWeight: 700,
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
                transform: 'translateY(-1px)',
                borderColor: alpha(theme.palette.primary.main, 0.72),
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                boxShadow: '0 12px 24px rgba(131, 83, 226, 0.12)',
            },
        })}
    >
        {label}
    </Button>
);
